<div class="bg-light-grey">
	<section>
		<!-- prettier-ignore -->
		<div class="max-w-full rounded-[12px]  ">
      <img alt="" class="w-full rounded-[12px]" onerror="'src/assets/images/empty state.jpg'"
        src="{{ attachmentPath }}{{organization?.coverUrl}}"></div>
		<!-- prettier-ignore -->
		<div class="-translate-y-16  background rounded-[12px] w-[90%] m-auto max-mobile:translate-y-4 max-mobile:mb-46px  mediumTab:mt-6">
      <div class=" px-24px max-mobile:px-8px justify-between minTab:flex flex-wrap max-h-[124px]">
        <div class="minTab:flex flex-wrap w-full ">
            <div class="h-[126px]  py-[13px]  ">
              <img alt="" class="rounded-full h-[100px] w-[100px] m-auto max-mobile:w-[50px] max-mobile:h-[50px]"
                onerror="'src/assets/images/logo-empty.svg'" src="{{ attachmentPath }}{{organization?.logoUrl}}" />
            </div>
          <div
            class="ml-[16px] w-1/2 py-[14px] max-mobile:py-padding-mobile-14 rtl:mr-[16px] rtl:ml-0 hidden minTab:flex">
            <div >
              <p
                class="mb-[6px] text-font-16 whitespace-nowrap text-dark-grey ltr:font-DIN-Bold font-bold rtl:font-medium leading[22px] inline-block max-mobile:text-font-mobile-medium max-mobile:m-0">

                {{organization?.businessName}}
            </p>
              <h2
                class="mb-[6px] text-medium-gray text-font-16  leading-[24px] max-mobile:text-font-mobile-small max-mobile:m-0">
                {{'ORGANIZATION.SP_PROFILE.BUSINESS_TYPE' |translate}}:
                {{translate.currentLang === 'en' ? organization?.type?.name?.en:organization?.type?.name?.ar }}
              </h2>
              <h2
                class="mb-[6px] text-medium-gray text-font-14  leading-[22px] max-mobile:text-font-mobile-small max-mobile:m-0">
                {{'GENERAL_LABELS.COUNTRY' |translate}}
                :
                {{translate.currentLang === 'en' ? organization?.country?.name?.en
                    :organization?.country?.name?.ar }}
              </h2>
            </div>
            <!-- SEPARATOR -->
            <div class="w-[1px] h-[27px] bg-secondry-color-Gray my-auto mx-[16px] max-mobile:mx-[5px]">
            </div>
            <!-- SEPARATOR -->
            <div class=" max-mobile:mt-0 ">
              <app-status *ngIf="organization?.status ==4 " [enumData]="status" [statusValue]="organization?.status"></app-status>
              <!-- CUSTOM STATUS -->
              <span  *ngIf="organization?.status !==4 " [ngClass]="organization.isActive  ? 'text-[#00BA88] bg-[#E2F5EE]' : 'text-[#B3261E] bg-[#FBE7E5]'"   class="whitespace-nowrap   text-font-[14px]  spanst-disc text-center rounded-[50px] inline-block py-1 px-[6px]">
              	<span [ngClass]="organization.isActive  ? 'bg-[#00BA88]' : 'bg-[#B3261E]'" class="w-[5px] h-[5px]  rounded inline-block align-middle"></span>
                  	{{ (organization.isActive ? "ACTIONS.ACTIVE"  : "ACTIONS.INACTIVE") |translate}}
                  </span>
              <h2
                class="mb-[6px]  text-medium-gray text-font-16  leading-[24px] max-mobile:text-font-mobile-small max-mobile:m-0 truncate">

                {{'ORGANIZATION.SP_PROFILE.ADMIN_NAME'|translate}}:
                {{ organization?.fullName | slice:0:15 }} {{organization?.fullName?.length&&organization.fullName.length > 15  ? '...' : ''}}


              </h2>
              <h2 *ngIf="organization.mobileNumber"
                class="mb-[6px] text-medium-gray text-font-14  leading-[22px] max-mobile:text-font-mobile-small max-mobile:m-0">
                {{'GENERAL_LABELS.MOBILE_NUMBER'|translate}} :
                {{organization?.mobileNumber}}
              </h2>
              <h2 *ngIf="organization?.email&&!organization.mobileNumber"
                class="mb-[6px] text-medium-gray text-font-14  leading-[22px] max-mobile:text-font-mobile-small max-mobile:m-0">
                {{'GENERAL_LABELS.EMAIL'|translate}} :
                {{organization?.email}}
              </h2>
            </div>
          </div>
          <div class="hidden minTab:block  absolute ltr:right-12 rtl:left-12 top-12 md:max-lg:mb-2 ">
            <button [routerLink]="'../view-business-details/'+organization.id" class="whitespace-nowrap bg-gradient pr-24px pl-[16px] py-[10px] rounded-[6px] mr-[6px] rtl:ml-[6px] rtl:mr-0 text-off-white text-font-14  leading-22px  max-mobile:py-[6px] w-full
             ">
              <img alt=""
                class="inline-block mr-[8px] rtl:ml-[8px] rtl:mr-0 " src="./assets/images/view-white.svg" />
              {{"ACTIONS.VIEW_DETAILS" |translate}}
            </button>
          </div>
          <div
          class=" pb-[14px]   minTab:hidden block w-full text-center">
            <div class="my-0 py-0">
              <p
              class="mb-0 text-font-16 text-dark-grey ltr:font-DIN-Bold font-bold rtl:font-medium ">

              {{organization?.businessName}}
            </p>
            <div >
              <app-status *ngIf="organization?.status ==4 " [enumData]="status" [statusValue]="organization?.status"></app-status>
              <!-- CUSTOM STATUS -->
              <span  *ngIf="organization?.status !==4 " [ngClass]="organization.isActive  ? 'text-[#00BA88] bg-[#E2F5EE]' : 'text-[#B3261E] bg-[#FBE7E5]'"   class="whitespace-nowrap   text-font-[14px]  spanst-disc text-center rounded-[50px] inline-block py-1 px-[6px]">
                <span [ngClass]="organization.isActive  ? 'bg-[#00BA88]' : 'bg-[#B3261E]'" class="w-[5px] h-[5px]  rounded inline-block align-middle"></span>
                    {{ (organization.isActive ? "ACTIONS.ACTIVE"  : "ACTIONS.INACTIVE") |translate}}
                  </span>

            </div>
            <div>
              <div class="flex justify-between mb-[6px] text-medium-gray text-font-14  px-3 ">
                <span>   {{'ORGANIZATION.SP_PROFILE.BUSINESS_TYPE' |translate}}:</span>
                <span>
                  {{translate.currentLang === 'en' ? organization?.type?.name?.en:organization?.type?.name?.ar }}
                </span>
              </div>

              <div class="flex justify-between mb-[6px] text-medium-gray text-font-14  px-3 ">
                <span>   {{'GENERAL_LABELS.COUNTRY' |translate}}
                  :</span>
                <span>
                  {{translate.currentLang === 'en' ? organization?.country?.name?.en
                  :organization?.country?.name?.ar }}
                </span>
              </div>

              <div class="flex justify-between mb-[6px] text-medium-gray text-font-14  px-3 ">
                <span>          {{'ORGANIZATION.SP_PROFILE.ADMIN_NAME'|translate}}:</span>
                <span>
                  {{ organization?.fullName | slice:0:15 }} {{organization?.fullName?.length&&organization.fullName.length > 15  ? '...' : ''}}
                </span>
              </div>

              <div *ngIf="organization.mobileNumber" class="flex justify-between mb-[6px] text-medium-gray text-font-14  px-3 ">
                <span>           {{'GENERAL_LABELS.MOBILE_NUMBER'|translate}} :</span>
                <span>
                  {{organization?.mobileNumber}}
                </span>
              </div>
              <div *ngIf="organization?.email&&!organization.mobileNumber"class="flex justify-between mb-[6px] text-medium-gray text-font-14  px-3 ">
                <span>   {{'GENERAL_LABELS.EMAIL'|translate}} :</span>
                <span>
                  {{organization?.email}}
                </span>
              </div>
            </div>
            </div>
        </div>
        </div>
        <div class="minTab:hidden block flex items-center minTab:w-full md:max-lg:m-auto md:max-lg:mb-2 ]">
          <button [routerLink]="'../../view-business-details/'+organization.id" class="whitespace-nowrap bg-gradient pr-24px pl-[16px] py-[10px] rounded-[6px] mr-[6px] rtl:ml-[6px] rtl:mr-0 text-off-white text-font-14  leading-22px  max-mobile:py-[6px] w-full  mb-[20px]
         	">
            <img alt=""
              class="inline-block mr-[8px] rtl:ml-[8px] rtl:mr-0 " src="./assets/images/view-white.svg" />
            {{"ACTIONS.VIEW_DETAILS" |translate}}
          </button>
        </div>
      </div>
    </div>

		<!-- Branches Section -->

		<section>
			<app-organization-profile-branches
				[organization]="organization"
			></app-organization-profile-branches>
		</section>
	</section>
</div>
